import ErrorView from 'vernio-theme/components/Blocks/Error/View';
import ErrorEdit from 'vernio-theme/components/Blocks/Error/Edit';
import OkAccedo from 'vernio-theme/components/OkAccedo/OkAccedo';

const applyConfig = (config) => {
  config.settings = {
    ...config.settings,
    // italiaThemeViewsConfig: {
    //   ...config.settings.italiaThemeViewsConfig,
    //   imagePosition: 'afterHeader', // possible values: afterHeader, documentBody
    // },
    siteProperties: {
      /*
        Per tutte le props di siteProperties, può essere definito un oggetto per i siti multilingua, strutturato in questo modo:
        {'default': _valore_della_prop, 'it': _valore_della_prop,...}
        Se l'oggetto non è strutturato in questo modo, viene usato l'oggetto stesso, altrimenti viene preso il valore della corrispondente alla prop della lingua corrente o alla prop 'default' se esiste.
      */
      ...config.settings.siteProperties,
      siteTitle: undefined,
      siteSubtitle: undefined,
      parentSiteTitle: 'Unione dei Comuni Val di Bisenzio',
      parentSiteURL: 'http://www.cmvaldibisenzio.it/',
      subsiteParentSiteTitle: undefined,
      showNextGenerationEU: false,
      arLoginUrl: '/oidc/login',
      arLogoutUrl: '/oidc/logout',
      spidLogin: true, //se true, nella pagina di errore Unauthorized, mostra il pulsante per il login a Spid.
    },

    'volto-gdpr-privacy': {
      ...config.settings['volto-gdpr-privacy'],
      defaultPanelConfig: null,
    },
  };

  config.settings.italiaThemeViewsConfig.imagePosition = 'documentBody'; // possible values: afterHeader, documentBody

  config.blocks.blocksConfig.error = {
    id: 'error',
    title: 'Error',
    view: ErrorView,
    edit: ErrorEdit,
    restricted: true,
    mostUsed: false,
    security: {
      addPermission: [],
      view: [],
    },
    sidebarTab: 0,
  };
  config.settings.appExtras = [
    ...(config.settings.appExtras || []),
    {
      match: '',
      component: OkAccedo,
    },
  ];

  return config;
};

export default applyConfig;
